<template>
  <div>
      <br>
    <div class="alert alert-block alert-success" role="alert">
       <h4> Atendimento finalizado.</h4>
       <p>
                  </p>
    </div>
  </div>
</template>

<script>
export default {
mounted(){   
}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/View/FinalizacaoFormularioAtendimentoAssistido.vue